<template>
  <div class="home">

    <b-image
            src="https://image.freepik.com/free-vector/people-making-list-illustration_53876-64623.jpg"
            webp-fallback=".jpg"
            ratio="16by8"

        ></b-image>


  </div>
</template>

<script>


export default {
  name: 'Home',
  components: {
  }
}
</script>
